import logger from "@/configs/logger";

const connectActivitySid = process.env.VUE_APP_CONNECT_ACTIVITY_SID;
const disconnectActivitySid = process.env.VUE_APP_DISCONNECT_ACTIVITY_SID;
const onlineActivitySid = process.env.VUE_APP_ONLINE_ACTIVITY_SID;

export class TaskRouterClient {
  worker!: any;

  constructor() {
    this.worker = {};
  }

  initialize(token: string): void {
    logger("log", "initializing task router");
    const debug = true;
    const closeExistingSessions = true;
    // @ts-ignore
    this.worker = new Twilio.TaskRouter.Worker(
      token,
      debug,
      connectActivitySid,
      disconnectActivitySid,
      closeExistingSessions
    );
  }

  setAvailability(available: boolean, cb?: Function): void {
    const activitySid = available ? onlineActivitySid : connectActivitySid;
    this.worker.update("ActivitySid", activitySid, cb);
  }
}

export default new TaskRouterClient();
